import _ from 'lodash';
import { LocalDateUtil } from 'wmic-portals-utils-js';

const getModalType = (step, page, isReadOnlyPlan) => {
    const changePaymentMsgKey = 'changePaymentPlan';
    const managePaymentMsgKey = 'managePaymentPlan';
    const viewPaymentMsgKey = 'viewPaymentPlan';

    if (step > page) {
        return changePaymentMsgKey;
    }

    if (isReadOnlyPlan) {
        return viewPaymentMsgKey;
    }

    return managePaymentMsgKey;
};

const generatePaymentData = (intl, group, key) => {
    const d = new Date(key);
    const dateObject = {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth(),
        day: d.getUTCDate()
    };

    const midnightDate = LocalDateUtil.toMidnightDate(dateObject);

    return {
        eventDate: intl.formatDate(
            midnightDate, { year: 'numeric', month: '2-digit', day: '2-digit' }
        ),
        amount: _.reduce(group, (memory, invoiceItem) => {
            const paidAmount = _.get(invoiceItem, 'paidAmount.amount', 0);
            return (memory + invoiceItem.amount.amount) - paidAmount;
        }, 0)
    };
};

export default {
    getModalType,
    generatePaymentData
};